import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-black border-t border-white/10 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-yellow-400 flex items-center justify-center">
              <span className="text-black font-black text-lg">K</span>
            </div>
            <span className="font-display text-xl tracking-tight text-white">KAWAN GRUISTA</span>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-zinc-400">
            <Link to="/termos" className="hover:text-yellow-400 transition-colors" data-testid="footer-terms">
              Termos de Uso
            </Link>
            <Link to="/privacidade" className="hover:text-yellow-400 transition-colors" data-testid="footer-privacy">
              Política de Privacidade
            </Link>
            <a
              href="https://wa.me/351963448484"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400 transition-colors"
              data-testid="footer-whatsapp"
            >
              WhatsApp · +351 963 448 484
            </a>
            <a
              href="mailto:info@manobradordegruakawan.com"
              className="hover:text-yellow-400 transition-colors"
              data-testid="footer-email"
            >
              info@manobradordegruakawan.com
            </a>
            <a
              href="https://www.livroreclamacoes.pt/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400 transition-colors"
              data-testid="footer-complaints"
            >
              Livro de Reclamações
            </a>
          </nav>
        </div>
        <div className="mt-8 pt-8 border-t border-white/10 text-xs text-zinc-500 leading-relaxed max-w-3xl">
          © 2026 Kawan Oliveira · Todos os direitos reservados. Este curso é um produto digital
          composto por aulas gravadas, disponíveis na área de membros da plataforma Hotmart. O
          acesso é individual e intransmissível. Pagamentos processados por Hotmart BV.
        </div>
      </div>
    </footer>
  );
}
